import React from "react";
import { ErrorMessage, Field } from "formik";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import {
  validateAge,
  validateName,
  validateRequired,
} from "../../../utilities/ValidationHelper";

const AboutTheSwimmersStep = () => {
  const ABOUT_THE_SWIMMERS_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.ABOUT_THE_SWIMMERS_STEP;
  return (
    <div className="step">
      <h4
        className="step-header"
        dangerouslySetInnerHTML={{
          __html: ABOUT_THE_SWIMMERS_STEP_STRINGS.HEADER_HTML,
        }}
      />
      <div className="question-container">
        <div className="form-group">
          <Field
            as="select"
            name="numberOfSwimmers"
            className="form-control"
            validate={validateRequired}
          >
            <option value="">
              {ABOUT_THE_SWIMMERS_STEP_STRINGS.NUMBER_OF_SWIMMERS}
            </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </Field>
          <ErrorMessage
            component="span"
            className="form-error"
            name="numberOfSwimmers"
          />
        </div>
        <div className="form-group">
          <Field
            name="swimmerName"
            className="form-control"
            placeholder={ABOUT_THE_SWIMMERS_STEP_STRINGS.SWIMMER_NAMES}
            validate={validateName}
          />
          <ErrorMessage
            component="span"
            className="form-error"
            name="swimmerName"
          />
        </div>
        <div className="form-group">
          <Field
            name="swimmerAge"
            className="form-control"
            placeholder={ABOUT_THE_SWIMMERS_STEP_STRINGS.SWIMMER_AGES}
            validate={validateAge}
          />
          <ErrorMessage
            component="span"
            className="form-error"
            name="swimmerAge"
          />
        </div>
        <div className="form-group">
          <Field
            as="select"
            name="waterComfortLevel"
            className="form-control"
            validate={validateRequired}
          >
            <option value="">
              {ABOUT_THE_SWIMMERS_STEP_STRINGS.WATER_COMFORT_LEVEL}
            </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </Field>
          <ErrorMessage
            component="span"
            className="form-error"
            name="waterComfortLevel"
          />
        </div>
        <div className="form-group">
          <Field
            as="select"
            name="levelOfSwimming"
            className="form-control"
            validate={validateRequired}
          >
            <option value="">
              {ABOUT_THE_SWIMMERS_STEP_STRINGS.LEVEL_OF_SWIMMING}
            </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </Field>
          <ErrorMessage
            component="span"
            className="form-error"
            name="levelOfSwimming"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutTheSwimmersStep;
